<template>
  <b-modal
    :active.sync="show"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    :width="1000"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <div v-if="jobDetails" class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Job Details 1</p>
      </header>
      <section class="modal-card-body">
        <h1>{{ jobDetails.job.name }}</h1>
        <br />
        <br />
        <a
          v-if="jobDetails.pdpReport"
          :href="jobDetails.pdpReport"
          target="blank"
          >View Full Report</a
        >
        <br />
        <br />

        <div v-if="!jobDetails.pdpReport">
          <div v-for="(value, name, index) in jobDetails" :key="index">
            <div v-if="name === 'job'">
              <h2>Job</h2>
              <div
                v-for="(jobValue, jobName, jobIndex) in jobDetails['job']"
                :key="jobIndex"
              >
                {{ jobName }}: {{ jobValue }}
              </div>
              <hr />
            </div>
            <div v-if="name === 'tasks'">
              <h2>Tasks</h2>
              <div v-for="tasks in jobDetails['tasks']">
                <div
                  v-for="(task, taskName, taskIndex) in tasks"
                  :key="taskIndex"
                >
                  {{ taskName }}: {{ task }}
                </div>
              </div>
              <hr />
            </div>
            <div v-if="name === 'errors'">
              <h2>Errors</h2>
              <div v-for="errors in jobDetails['errors']">
                <div
                  v-for="(error, errorName, errorIndex) in errors"
                  :key="errorIndex"
                >
                  {{ errorName }}: {{ error }}
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot" style="justify-content: flex-end">
        <button class="button" type="button" @click="closeModal">
          Close
        </button>
        <button
          v-if="jobDetails.job.status === 'failed'"
          class="button is-primary"
          @click="confirmOverrideQC()"
        >
          Override QC
        </button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import HybrikApi from '@/api/hybrik'

export default {
  name: 'ViewHybrikJobResult',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    jobId: {
      // type: Number,
      default: null,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      initialized: false,
      showModal: this.show,
      result: {},
      jobDetails: null
    }
  },

  async created() {
    this.initialized = true
    await this.fetchResult()
  },
  methods: {
    confirmOverrideQC() {
      this.$buefy.dialog.confirm({
        message: "Are you sure you want to override Hybrik's Quality Control?",
        onConfirm: async () => {
          console.log(this.jobDetails)
          await HybrikApi.qcOverride(this.jobDetails.job.id)
          this.$emit('refresh')
        }
      })
    },
    async fetchResult() {
      console.log('JOBID: ', this.jobId)
      const res = await HybrikApi.getJobResult(this.jobId)
      console.log(res)

      let pdfPath = ''
      if (
        res &&
        res.tasks &&
        res.tasks[2] &&
        res.tasks[2].config &&
        res.tasks[2].config.payload &&
        res.tasks[2].config.payload.report
      ) {
        const location = res.tasks[2].config.payload.report.location.path
        const fileName = res.tasks[2].config.payload.report.file_pattern
        pdfPath = `${location.replace(
          's3://',
          'https://s3.af-south-1.amazonaws.com/'
        )}/${fileName}`
      }

      this.jobDetails = res
      this.jobDetails.pdpReport = pdfPath
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    }
  }
}
</script>
